export default __webpack_public_path__ + "static/media/github.12aecd2f.png";